/** Return to Home: signed-in providers land on home; everyone else goes to login. */
export function returnHomeOrLoginPath(isAuthenticated: boolean): '/' | '/login' {
  return isAuthenticated ? '/' : '/login'
}
